module.exports = require("@carvana/icons/AlertCircle");